import { combineReducers } from 'redux';

import form from './form';
import recover from './recover';
import resend from './resend';

export default combineReducers({
  form,
  recover,
  resend,
});
